<section class="mb-13 mb-md-14">
    <app-video
        [title]="'HERO_VIDEO.title'"
        [backgroundImage]="'/assets/images/movie_about-us-bcg.png'"
        [videos]="['/assets/videos/about-us-video.av1.mp4', '/assets/videos/about-us-video.hevc.mp4', '/assets/videos/about-us-video.h264.mp4']"
        [btnText]="'HERO_VIDEO.btn'"
    ></app-video>
</section>
<section class="mb-13 mb-md-14">
    <app-title title="ABOUT_US.page_title" subtitle="ABOUT_US.page_subtitle"></app-title>
</section>
<section class="mb-13 mb-md-14">
    <app-history-1></app-history-1>
</section>
<section class="mb-13 mb-md-14">
    <app-history-2></app-history-2>
</section>
<section class="bg-gray-150 py-13 py-md-14 mb-13 mb-md-14">
    <app-our-products></app-our-products>
</section>
